import { Link } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import { useStore } from "../hooks";

const HomeProducts = () => {
  const { isMenuLoading, storeLocations, storeCategories } = useStore();

  if (isMenuLoading) {
    return (
      <Row className="g-3 gx-lg-3 gy-lg-2">
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((item) => (
          <Col xs="6" sm="4" md="4" lg="3" key={item}>
            <Skeleton height={150} />
          </Col>
        ))}
      </Row>
    );
  }

  return (
    <div className="home_category mb-3">
      <Row className="g-3 g-lg-3">
        {storeCategories
          .filter((c) => c.parent_id === "0")
          .map((category) => (
            <Col xs="6" sm="4" md="4" lg="3" key={category.store_category_id}>
              <Link to={`/menu/${category.store_category_id}`}>
                <span className="home_category_product">
                  <span className={"overlay"}></span>
                  {category.category_image ? (
                    <img src={category.category_image} alt="img-fluid" />
                  ) : (
                    <img
                      className="no-image"
                      src={storeLocations?.background_image}
                      alt="img-fluid"
                    />
                  )}
                  {/* <span className="category-title-row"> */}
                  <h6 className="text-center">
                    {category.category_name.toUpperCase()}
                  </h6>
                  {/* <ArrowRight size={18} /> */}
                  {/* </span> */}
                </span>
              </Link>
            </Col>
          ))}
      </Row>
    </div>
  );
};

export default HomeProducts;
